import StarFill from './StarFill';

export default StarFill;
